export default __webpack_public_path__ + "static/media/sidebar-icon-dashboard.b8188421.svg";